// extracted by mini-css-extract-plugin
module.exports = {"title":"AssetListTitle-module--title--2O1WN"};